import { kzs as _kzs } from "@kaizenplatform/cse-tools";
import { selectFetchDistination } from "./module/fetch";
import { Config, inspectBreakDown } from "./variation/embedArea";
const kzs = window.kzs;

const expScript = (context: _kzs.precedingJsContext): Promise<void> => {
  kzs.console.log(context);
  const Promise = kzs.Promise;

  const main = (config: Config) => {
    const url = selectFetchDistination();
    kzs.console.log(`url: `, url);
    inspectBreakDown(config, url);
  };

  return Promise.resolve().then(() => {
    window.kzNTTWestEmbed = {
      run: (config: Config) => {
        kzs.console.log(`config: `, config);
        try {
          main(config);
        } catch (e) {
          const logData = {
            category: "inspectBreakDown",
            action: "render",
            exp: context.variation?.round.project.id,
            data: { exception: e },
          };
          kzs.console.log(`send ${"inspectBreakDown"} logData:`, logData);
          kzs("trackCustomEvent", logData);
        }
      },
    };
  });
};

export default expScript;
